import { render, staticRenderFns } from "./periodo_config_institucion.vue?vue&type=template&id=45df4d7c"
import script from "./periodo_config_institucion.vue?vue&type=script&lang=js"
export * from "./periodo_config_institucion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports